// Migrated
<template>
  <InfoCarousel v-bind="infoCarouselProps">
    <div class="flex flex-col pt-6 pb-12 px-4 xl:px-4">
      <div
        v-if="facilities?.length"
        class="block mr-6 mb-2"
      >
        <FacilityIconLabel
          v-for="facility in facilities"
          :key="facility"
          class="text-nowrap mb-2"
          :facility="facility"
        />
      </div>
      <div>
        <LocationText v-bind="location" />
        <slot />
      </div>
    </div>
  </InfoCarousel>
</template>

<script>
import InfoCarousel from '@layers/web/components/carousels/InfoCarousel'

export default defineNuxtComponent({
  props: {
    ...InfoCarousel.props,
    /**
     * @prop {
     *   destination: string
     *   postcode: string
     *   locality: string
     *   city: string
     *   country: string
     * } location
     */
    location: {
      type: Object,
      default: () => ({}),
    },

    facilities: {
      type: Array,
      default: () => [],
    },
  },

  data () {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const { location, facilities, ...infoCarouselProps } = this.$props

    return {
      infoCarouselProps,
    }
  },
})
</script>
